module.exports = __webpack_public_path__ + "img/jljd.43f367d6.png";